import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, HtmlTrans, Progress, Typography } from 'web-library';

const UploadingInProgress = ({
  uploadedFiles,
  classes,
}: {
  uploadedFiles: File[];
  classes: any;
}) => {
  const { t } = useTranslation();

  return (<>
    <Box className={classes.uploadingDescription}>
      <HtmlTrans i18nKey="exam->>ExamConfiguration.UploadingInProgress" />
    </Box>
    <Grid className={classes.fileBadgeParentContainer}>
      <Grid
        container
        md={8}
        xs={12}
        direction="row"
        alignItems="center"
        justify="flex-start"
        wrap="nowrap"
        className={classes.fileBadgeContainer}
      >
        <Grid className={classes.iconContainer}>
          <Progress size="S" type="circle" />
        </Grid>
        <Typography noWrap className={classes.filename}>
          {t('exam->>ExamConfiguration.Uploading')} {uploadedFiles[0].name}
        </Typography>
      </Grid>
    </Grid>
  </>);
};

export default UploadingInProgress;
